module.exports = __webpack_public_path__ + "img/welcome.8dfbed47.png";